import apiClient from "./api";

const HISTORIAL_API_BASE_URL = "/historialEstudios";

class HistorialEstudiosService {

  async getHistorialPorEstudio(idSolicitud, idEstudio) {
    try {
      const response = await apiClient.get(
        `${HISTORIAL_API_BASE_URL}/${idSolicitud}/${idEstudio}`
      );
      if (response.data && response.data.estatus === "OK") {
        return response.data.historial || [];
      }
    } catch (error) {
      console.warn("Servidor backend de historial no disponible, recurriendo a almacenamiento local:", error);
    }

  }

  async getHistorialSolicitudImpresionEnvio(idSolicitud) {
    try {
      const response = await apiClient.get(
        `${HISTORIAL_API_BASE_URL}/solicitud/${idSolicitud}`
      );
      if (response.data && response.data.estatus === "OK") {
        return response.data.historial || [];
      }
    } catch (error) {
      console.warn("Servidor backend de historial no disponible, recurriendo a almacenamiento local:", error);
    }

  }

  async registrarMovimiento(datos) {
    const payload = {
      idSolicitud: datos.idSolicitud,
      idEstudio: datos.idEstudio,
      nombreEstudio: datos.nombreEstudio || "",
      nombreEmpleado: datos.nombreEmpleado || "SISTEMA",
      tipoAccion: datos.tipoAccion, // 'L', 'R', 'V', 'P', 'I', 'D'
    };

    try {
      const response = await apiClient.post(HISTORIAL_API_BASE_URL, payload);
      return response.data;
    } catch (error) {
      console.warn("Error al enviar registro al backend, mantenido en cache local:", error);
      return { estatus: "OK", mensaje: "Guardado localmente" };
    }
  }

  async registrarMovimientoMasivo(listaDatos) {
    if (!Array.isArray(listaDatos) || listaDatos.length === 0) return;

    const payload = listaDatos.map((item) => ({
      idSolicitud: item.idSolicitud,
      idEstudio: item.idEstudio,
      nombreEstudio: item.nombreEstudio || "",
      nombreEmpleado: item.nombreEmpleado || "SISTEMA",
      tipoAccion: item.tipoAccion,
    }));

    try {
      const response = await apiClient.post(HISTORIAL_API_BASE_URL, payload);
      return response.data;
    } catch (error) {
      console.warn("Error al enviar registros masivos al backend, mantenido en cache local:", error);
      return { estatus: "OK", mensaje: "Guardado localmente" };
    }
  }
}

export default new HistorialEstudiosService();
